/**
 * /devhub/workers — Workers (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubWorkerRegistryPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubWorkerRegistryPanel } from '../features/control-plane/DevHubWorkerRegistryPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/workers')({ component: WorkersPage });

function WorkersPage() {
  return (
    <DevHubPanelPage
      title="Workers"
      subtitle="Local worker runtime registry — registration status vs live process status."
      status={{ label: 'live', live: true }}
    >
      <DevHubWorkerRegistryPanel />
    </DevHubPanelPage>
  );
}
